import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { DateAdapter } from '@angular/material/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { subDays, startOfMonth, endOfMonth, format, isValid, addDays, setMonth } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { Helps } from 'src/app/libs/helps';
import { Paginate } from 'src/app/models/interfaces/paginate';
import { ApiEntryControlService } from '../../api-entry-control.service';
import { Facility } from '../../interfaces/facility';
import { Records } from '../../interfaces/records';
import { Stores } from '../../interfaces/stores';
import { Subscription, interval } from 'rxjs';
import { RoundsConfiguration } from '../../interfaces/rounds_configuration';
import { RoundsRecords } from '../../interfaces/rounds_records';

@Component({
  selector: 'app-admin-rounds',
  templateUrl: './admin-rounds.component.html',
  styleUrl: './admin-rounds.component.css'
})
export class AdminRoundsComponent implements OnInit {
  error: any;
  constructor(
    private api: ApiEntryControlService,
    private toast: ToastrService,
    private helps: Helps,
    private modal: NgbModal,
    private dateAdapter: DateAdapter<Date>

  ) { }

  @Input()
  facilityId:number;

  view: number = 1;
  status: any;
  categorys: any;
  idSelected: number = 0;
  ngOnInit(): void {
    this.dateAdapter.setLocale('es'); // Establece el idioma de las fechas a español
    this.mesActual = new Date();
    if(this.facilityId>0){
      this.get(); 
    }
   
  }

  items: RoundsConfiguration[];
  page = 1;
  perpage: number = 0;
  collectionSize = 0;
  totalPage = 0;

  facilityes:Facility[];
  stores:Stores[];

  brands: any;
  form = new UntypedFormGroup({
    id: new UntypedFormControl(),
    start: new UntypedFormControl(),
    end: new UntypedFormControl()
  });

  setDaysStartEnd() {
      this.inicioMes = startOfMonth(this.mesActual);
      this.finMes = endOfMonth(this.mesActual);
    this.form.controls['start'].setValue(this.inicioMes.toISOString().substring(0, 10));
    this.form.controls['end'].setValue(this.finMes.toISOString().substring(0, 10));
    this.get();
  }
  get() {
    this.api.paginateMyRounds(this.page, this.form).subscribe(
      (response) => {
        var data = response.data as Paginate;
        this.items = data.items as RoundsConfiguration[];
        this.items.forEach((item: RoundsConfiguration) => {
          if (item.rounds_records) {
            item.rounds_records = item.rounds_records.filter((record: RoundsRecords) => record.status_id == 1);
          }
        });
               
        this.page = data.current;
        this.perpage = data.per_page;
        this.collectionSize = data.count;
        console.log(this.collectionSize);
        this.totalPage = data.total;
      },
      (e) => {
        this.items = [];
        this.page = 1;
        this.collectionSize = 0;
        this.totalPage = 0;
      }
    );
  }


  search() {
    this.get();
  }


  mesView: string;
  mesActual: Date;
  fechas: Date[];
  //dia inicial del mes
  inicioMes: Date;

  //dia final del mes
  finMes: Date;
  setStartDay(event: any) {
    this.form.get('start')?.setValue(event.value);
  }

  cambiarMes(delta: number): void {
    this.mesActual = setMonth(this.mesActual, this.mesActual.getMonth() + delta);
    this.mesView = this.mesActual.toISOString();
    this.setDaysStartEnd();
  
  }

  obtenerNombreMes(mes: number): string {
    const nombresMeses = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];

    return nombresMeses[mes];
  }
  openModal(mdl: any) {
    this.modal.open(mdl);
  }


}